/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { bitcoinGetApiV3BitcoinMainChainHeight } from "../../funcs/bitcoinGetApiV3BitcoinMainChainHeight.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3BitcoinMainChainHeightRequest$inboundSchema
    .optional(),
};

export const tool$bitcoinGetApiV3BitcoinMainChainHeight: ToolDefinition<
  typeof args
> = {
  name: "bitcoin-get-api-v3-bitcoin-main-chain-height",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await bitcoinGetApiV3BitcoinMainChainHeight(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
